import IFACE, { EL } from './IFACE.js';
import Refresh from '../event/Refresh.js';
/** An interface for Refresh driven Events */
export default class Refreshable extends IFACE {
    options;
    /** A series of Refresh Related Events and Methods
        A 'refreshable' element is capable of performing the following events:
            - Refresh event performs necessary actions to GET the object model and update the DOM
        @todo Stop Propagation could use some work
        @param {EL} node Class to implement this interface (Typically 'this')
        @param {RefreshableOptions} options Click Timer Options
    */
    constructor(node, options = {
        'refresh-timeout': 1000,
        'refresh-repeat-enabled': false,
        'refresh-repeat': 5000
    }) {
        super(node, 'refreshable');
        this.options = options;
        node.timer = null;
        node.refresh = () => console.log('Missing refresh() method for ' + node.toString(), node);
    }
    /** Calls Event.preventDefault attached to an Event Listener
        @param {Event} ev Event
    */
    preventDefault(ev) {
        ev.preventDefault();
    }
    addListeners(node) {
        // Refresh the Object model
        node.on('refresh', (ev) => node.refresh(node, ev)); //, { passive: true }
    }
    /** On Refresh Event, sets 'refreshing' class and triggers the refresh() method
        @param {EL} node Element to implement methods
        @param {Event} ev Event
    */
    refresh(node, ev) {
        node.addClass('refreshing').refresh(node, ev).then(() => node.removeClass('refreshing'));
    }
    /** Appends Interface methods to class that implements them
        @param {EL} node Element to implement methods
    */
    setMethods(node) {
        /** Dispatches a Refresh Event
            @param ev Event
        */
        this.methods.refresh = (ev) => this.refresh(node, ev);
    }
}
export { EL, IFACE, Refresh };
